<div class="welcome__container px-5 pb-5">
  <h1 class="text-white headline font-size-headline1">WELCOME TO UDTHUB</h1>
  <h2 class="m-0 text-white font-size-headline5 subheadline">One-stop, self-service customer portal</h2>
  <div class="d-flex mt-5">
    <div class="app__container d-flex justify-content-center align-items-center">
      <button
        mat-icon-button
        class="text-white left"
        aria-label="Back hub feature button"
        type="button"
        (click)="leftClick()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="carousel__content w-100">
        @for (portal of carouselPortals; track portal.addonName + $index; let i = $index) {
          <div class="carousel__content--slide">
            <div (click)="onCustomerPortalClicked(portal)" style="cursor: pointer">
              <img
                class="mb-2"
                src="../../../../../assets/images/icons/{{ portal.icon }}"
                [ngStyle]="{ width: portal.iconSize }"
                alt=""
              />
              <h4 class="m-0 py-2 text-white font-size-body subheadline2">{{ portal.name }}</h4>
              <p class="m-0 text-white">{{ portal.description }}</p>
            </div>
          </div>
        }
      </div>
      <button
        mat-icon-button
        class="text-white right"
        aria-label="Next hub feature button"
        type="button"
        (click)="rightClick()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
